import './app/ars-embed/partner-launch-sandbox';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { applyConsolePolicy } from './app/console-policy';

if (environment.production) {
  enableProdMode();
}

// HIER: Das deaktiviert die Logs effektiv
applyConsolePolicy(environment);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
